<template>
  <div>
    <div class="field url required podcast_url">
      <div>
        <label class="url required" for="podcast_url">
          Enter your podcast name
          <abbr title="required">*</abbr>
        </label>
        <typeahead
          fieldName="podcast[url]"
          v-bind:searchFunc="search"
          v-bind:onChange="searchChange"
          id="podcast_url"
        ></typeahead>
        <input type="hidden" v-model="artwork" name="podcast[artwork]" />
        <input type="hidden" v-model="title" name="podcast[title]" />
      </div>
    </div>
    <div class="flex justify-between pb-5">
      <a
        class="text-sm text-gray-600 modal-link"
        href="/sign_up/contact"
      >More than one podcast?</a>
    </div>
  </div>
</template>

<script>
import Typeahead from "components/typeahead";

export default {
  components: {
    typeahead: Typeahead
  },
  data: function() {
    return {
      artwork: null,
      title: null
    };
  },
  methods: {
    search: async function(searchTerm) {
      const results = await fetch(`/api/show_lookup?q=${searchTerm}`);
      const json = await results.json();

      if (window.analytics) {
        window.analytics.logEvent("Action - Signup - Podcast Search", {
          searchTerm: searchTerm,
          numberResults: json.length,
          matches: json.map(p => p.collectionName)
        });
      }


      let collection = json.map(podcast => ({
        id: podcast.feedUrl,
        label: podcast.collectionName,
        artworkImage: podcast.artworkUrl600,
        title: podcast.collectionName,
        feedUrl: podcast.feedUrl
      }))

      collection.push({
        id: null,
        label: "My podcast isn't listed",
        artworkImage: null,
        title: searchTerm
      })

      return collection;
    },
    searchChange: async function(item) {
      if (item.id != null) {
        const preview = document.querySelector("#podcast-preview");

        preview.src =
          "/previews?&podcast_url=" +
          encodeURIComponent(item.id) +
          "&artwork=" +
          encodeURIComponent(item.artworkImage) +
          "&title=" +
          encodeURIComponent(item.title);
        document.querySelector(".device").scrollIntoView();
      }
      document.querySelector(
        ".sc-form.podcast input[type='submit']"
      ).disabled = false;

      this.artwork = item.artworkImage;
      this.title = item.title;

      const results = await fetch(`/sign_up/channel_exists?title=${item.title}&feedUrl=${item.feedUrl}`);
      const json = await results.json();

      if (json.channel_exists) {
        document.querySelector('#channel-title').innerHTML = item.title;
        document.querySelector('#channel-url').setAttribute('href', json.url);

        document.querySelector("#podcast-already-exists").classList.remove("hidden");
        document.querySelector("#podcast-metadata").classList.add("hidden");
        document.querySelector(
          ".sc-form.podcast input[type='submit']"
        ).classList.add("hidden");
      } else {
        document.querySelector("#podcast-already-exists").classList.add("hidden");
        document.querySelector("#podcast-metadata").classList.remove("hidden");
        document.querySelector(
          ".sc-form.podcast input[type='submit']"
        ).classList.remove("hidden");
      };
    }
  }
};
</script>
